//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import * as React from 'react';
import { connect } from 'react-redux';
import Redux, { bindActionCreators } from 'redux';

import { instagramPostUploaderActions } from '@instagram-post-uploader/actions/instagramPostUploaderActions';
import { addUniversalUploadListener } from '@react-bridge/wrappers/legacy-events';
import styled from 'styled-components';

import illyEmptyImage from '@images/content-library/cl_illy_empty.svg';

function mapDispatchToProps(dispatch: Redux.Dispatch) {
  return {
    actions: {
      postUploader: bindActionCreators(instagramPostUploaderActions, dispatch),
    },
  };
}

type Props = ReturnType<typeof mapDispatchToProps>;

class FileSystemUploadForm extends React.Component<Props> {
  private unsubscribeFromFileSystemListener: () => void;

  public componentDidMount() {
    this.listenForFileSystemUpload();
  }

  public componentWillUnmount() {
    if (typeof this.unsubscribeFromFileSystemListener === 'function') {
      this.unsubscribeFromFileSystemListener();
    }
  }

  public listenForFileSystemUpload = () => {
    this.unsubscribeFromFileSystemListener = addUniversalUploadListener(() => {
      this.props.actions.postUploader.closeInstagramPostUploaderModal();
    });
  }

  public render() {
    return (
      <>
        <SizedImage src={ illyEmptyImage } />
        <div>Upload media from your desktop</div>
        <label className='cu-button-default cu-mt-3' htmlFor='file-input-universal-overlay'>
          Upload
        </label>
      </>
    );
  }
}

const SizedImage = styled.img`
  margin-bottom: ${({ theme }) => theme.spacings[4]};
  max-width: 132px;
`;

export default connect(null, mapDispatchToProps)(FileSystemUploadForm);
